import { render, staticRenderFns } from "./material-education.vue?vue&type=template&id=c0de8fa4&scoped=true&"
import script from "./material-education.vue?vue&type=script&lang=js&"
export * from "./material-education.vue?vue&type=script&lang=js&"
import style0 from "./material-education.vue?vue&type=style&index=0&id=c0de8fa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0de8fa4",
  null
  
)

export default component.exports